<dspx-card-set-base-form *ngIf="isServiceWorkerReady$ | async"
                         [fieldTypeReplacements]="fieldTypeReplacements"
                         [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         formName="SOR Description"
                         [entityId]="id"
                         (onFormLoad)="formLoaded($event)"
                         (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-form>
